/* Portal de Consignação Printar */
(function () {
  'use strict';

  const API = 'https://elasticyear.com/api/printar/consignment';
  let sessionToken = null;
  let clientData   = null;
  let stockData    = [];
  let stockRes     = null;
  let kitLimite    = 0;
  let catalogData  = [];

  // ── Utilitários ──────────────────────────────────────────────────────────────

  function qs(sel, ctx = document) { return ctx.querySelector(sel); }
  function qsa(sel, ctx = document) { return [...ctx.querySelectorAll(sel)]; }

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  function toast(msg, type = 'success', duration = 4000) {
    const container = qs('.consig-toasts') || (() => {
      const d = document.createElement('div');
      d.className = 'consig-toasts';
      document.body.appendChild(d);
      return d;
    })();
    const t = document.createElement('div');
    t.className = `consig-toast consig-toast--${type}`;
    t.textContent = msg;
    container.appendChild(t);
    setTimeout(() => t.remove(), duration);
  }

  function fmt(value) {
    return Number(value).toLocaleString('pt-PT', { style: 'currency', currency: 'EUR' });
  }

  async function apiFetch(path, options = {}) {
    const headers = { 'Content-Type': 'application/json' };
    if (sessionToken) headers['X-Session-Token'] = sessionToken;

    const res = await fetch(API + path, { ...options, headers, credentials: 'include' });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'Erro na API.');
    return json;
  }

  // ── Tabs ─────────────────────────────────────────────────────────────────────

  function initTabs() {
    qsa('.consig-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        qsa('.consig-tab').forEach(t => t.classList.remove('is-active'));
        qsa('.consig-tab-panel').forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const panel = qs(`[data-panel="${btn.dataset.tab}"]`);
        if (panel) panel.classList.add('is-active');

        // Carregar dados se necessário
        if (btn.dataset.tab === 'catalogo' && catalogData.length === 0) loadCatalog();
        if (btn.dataset.tab === 'reporte')  renderReportForm();
        if (btn.dataset.tab === 'reposicao') renderReorderForm();
        if (btn.dataset.tab === 'kit') renderKitForm();
      });
    });
  }

  // ── Autenticação ─────────────────────────────────────────────────────────────

  async function initPortal(customerId) {
    const root = qs('[data-consig-root]');
    if (!root) return;

    root.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div> A carregar...</div>';

    try {
      const res = await apiFetch('/session.php', {
        method: 'POST',
        body: JSON.stringify({ customer_id: parseInt(customerId) }),
      });

      if (!res.authenticated) {
        showStatusPage(res.estado);
        return;
      }

      sessionToken = res.token;
      clientData   = res.cliente;

      await loadPortal();
    } catch (err) {
      root.innerHTML = `<div class="consig-loading">Erro ao iniciar sessão. Tenta recarregar a página.</div>`;
    }
  }

  async function initPortalPreview(adminCid, previewShopifyCid) {
    const root = qs('[data-consig-root]');
    if (!root) return;

    root.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div> A carregar pré-visualização...</div>';

    try {
      const res = await apiFetch('/session.php', {
        method: 'POST',
        body: JSON.stringify({ admin_cid: parseInt(adminCid), preview_shopify_cid: parseInt(previewShopifyCid) }),
      });

      if (!res.authenticated) {
        root.innerHTML = `<div class="consig-loading">Cliente não encontrado ou não aprovado.</div>`;
        return;
      }

      sessionToken = res.token;
      clientData   = res.cliente;

      await loadPortal(true);
    } catch (err) {
      root.innerHTML = `<div class="consig-loading">Erro ao carregar pré-visualização: ${err.message}</div>`;
    }
  }

  function showStatusPage(estado) {
    const root = qs('[data-consig-root]');

    if (estado === 'sem_registo') {
      root.innerHTML = '';
      const landing = qs('#consig-landing');
      if (landing) {
        landing.style.display = '';
        initRegisterForm();
      }
      return;
    }

    const states = {
      pendente:     { icon: '⏳', title: 'Pedido em análise', text: 'O teu pedido de consignação está a ser analisado. Receberás um e-mail quando for aprovado.' },
      suspenso:     { icon: '🔒', title: 'Conta suspensa', text: 'A tua conta de consignação foi suspensa. Contacta-nos para mais informações.' },
      desconhecido: { icon: '❓', title: 'Estado desconhecido', text: 'Não conseguimos determinar o estado da tua conta. Contacta o suporte.' },
    };
    const s = states[estado] || states.desconhecido;
    root.innerHTML = `
      <div class="consig-status-page">
        <div class="consig-status-page__inner">
          <div class="consig-status-page__icon">${s.icon}</div>
          <h2 class="consig-status-page__title">${s.title}</h2>
          <p class="consig-status-page__text">${s.text}</p>
        </div>
      </div>`;
  }

  // ── Portal principal ──────────────────────────────────────────────────────────

  async function loadPortal(isPreview = false) {
    const root = qs('[data-consig-root]');
    root.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div> A carregar...</div>';

    // Fetch stock before building tabs so we know which tabs to show
    try {
      const res = await apiFetch('/consignment/stock.php');
      stockRes  = res;
      stockData = res.stock || [];
      kitLimite = res.limite_kit || 0;
    } catch {}

    const hasStock = stockData.length > 0;

    const previewBanner = isPreview ? `
      <div class="consig-preview-banner">
        <span>Pré-visualização admin — a ver como: <strong>${clientData.nome_negocio}</strong></span>
        <a href="/pages/consignacao-admin" class="consig-preview-back">Voltar ao painel</a>
      </div>` : '';

    let tabBtns = `<button class="consig-tab is-active" data-tab="stock">Stock em campo</button>`;
    let tabPanels = `<div class="consig-tab-panel is-active" data-panel="stock"></div>`;

    if (hasStock) {
      tabBtns   += `<button class="consig-tab" data-tab="reporte">Reportar vendas</button>`;
      tabBtns   += `<button class="consig-tab" data-tab="reposicao">Pedir reposição</button>`;
      tabPanels += `<div class="consig-tab-panel" data-panel="reporte"></div>`;
      tabPanels += `<div class="consig-tab-panel" data-panel="reposicao"></div>`;
    }

    tabBtns   += `<button class="consig-tab" data-tab="catalogo">Catálogo</button>`;
    tabPanels += `<div class="consig-tab-panel" data-panel="catalogo">
      <div class="consig-loading"><div class="consig-spinner"></div> A carregar catálogo...</div>
    </div>`;

    root.innerHTML = `
      ${previewBanner}
      <div class="consig-portal">
        <div class="consig-portal__header">
          <div>
            <h1 class="consig-portal__title">Portal de Consignação</h1>
            <p class="consig-portal__sub">${clientData.nome_negocio}</p>
          </div>
        </div>
        <div class="consig-tabs">${tabBtns}</div>
        ${tabPanels}
      </div>`;

    initTabs();
    if (stockRes) renderStock(stockRes);
  }

  // ── Stock ─────────────────────────────────────────────────────────────────────

  async function loadStock() {
    try {
      const res = await apiFetch('/consignment/stock.php');
      stockRes  = res;
      stockData = res.stock || [];
      kitLimite = res.limite_kit || 0;
      renderStock(res);
    } catch (err) {
      const panel = qs('[data-panel="stock"]');
      if (panel) panel.innerHTML = `<div class="consig-alert-inline consig-alert-inline--danger">Erro ao carregar stock: ${err.message}</div>`;
    }
  }

  function renderStock(res) {
    const panel = qs('[data-panel="stock"]');
    const stock = res.stock || [];
    const pagamentoPendente = res.pagamento_pendente;
    const ultimoReporte     = res.ultimo_reporte;
    const limite            = res.limite_kit;

    const totalUnidades = stock.reduce((s, i) => s + parseInt(i.qty_atual), 0);

    let html = '';

    if (pagamentoPendente) {
      const r = ultimoReporte;
      html += `<div class="consig-alert-inline consig-alert-inline--warning">
        ⚠️ Tens um pagamento pendente de <strong>${fmt(r.valor_total)}</strong> (encomenda #${r.shopify_order_number}).
        O pedido de reposição ficará disponível após o pagamento.
      </div>`;
    }

    const descontoPct  = res.desconto_pct  || 0;
    const tierLabel    = res.tier_label    || 'Sem desconto';
    const totalVendido = res.total_vendido || 0;
    const proximoTier  = res.proximo_tier  || null;

    // Tier colors
    const tierColors = { Bronze: '#b87333', Silver: '#8a9099', Gold: '#c9961f', Platinum: '#5b6e82' };
    const tierColor  = tierColors[tierLabel] || '#555';

    // Donut SVG
    const R    = 44;
    const circ = +(2 * Math.PI * R).toFixed(2);
    const prog = proximoTier ? Math.min(100, (totalVendido / proximoTier.min_vendido) * 100) : 100;
    const off  = +(circ * (1 - prog / 100)).toFixed(2);

    html += `<div class="consig-metrics">
      <div class="consig-metric">
        <div class="consig-metric__label">Produtos em campo</div>
        <div class="consig-metric__value">${totalUnidades}</div>
      </div>
      <div class="consig-metric">
        <div class="consig-metric__label">Referências</div>
        <div class="consig-metric__value">${stock.length}</div>
      </div>
      <div class="consig-metric ${pagamentoPendente ? 'consig-metric--danger' : ''}">
        <div class="consig-metric__label">Pagamento</div>
        <div class="consig-metric__value">${pagamentoPendente ? 'Pendente' : 'Em dia'}</div>
      </div>
    </div>

    <div class="consig-tier-card">
      <svg viewBox="0 0 120 120" width="110" height="110" style="flex-shrink:0">
        <circle cx="60" cy="60" r="${R}" fill="none" stroke="rgba(0,0,0,.08)" stroke-width="11"/>
        <circle cx="60" cy="60" r="${R}" fill="none"
          stroke="${tierColor}" stroke-width="11"
          stroke-dasharray="${circ}" stroke-dashoffset="${off}"
          stroke-linecap="round"
          transform="rotate(-90 60 60)"
          style="transition:stroke-dashoffset .7s ease"/>
        <text x="60" y="54" text-anchor="middle" dominant-baseline="middle"
          font-size="21" font-weight="700" fill="${tierColor}" font-family="inherit">
          ${descontoPct > 0 ? descontoPct + '%' : '—'}
        </text>
        <text x="60" y="73" text-anchor="middle" dominant-baseline="middle"
          font-size="10" fill="currentColor" opacity=".45" font-family="inherit">desconto</text>
      </svg>
      <div class="consig-tier-card__info">
        <div class="consig-tier-card__eyebrow">Ranking</div>
        <div class="consig-tier-card__name" style="color:${tierColor}">${tierLabel}</div>
        ${proximoTier ? `
          <div class="consig-tier-card__next">
            Faltam <strong>${fmt(proximoTier.faltam)}</strong> para ${proximoTier.label || proximoTier.desconto_pct + '%'}
          </div>
          <div class="consig-tier-card__bar-wrap">
            <div class="consig-tier-card__bar" style="width:${prog.toFixed(1)}%;background:${tierColor}"></div>
          </div>
          <div class="consig-tier-card__bar-labels">
            <span>${fmt(totalVendido)}</span><span>${fmt(proximoTier.min_vendido)}</span>
          </div>
        ` : `<div class="consig-tier-card__next">Nível máximo atingido 🏆</div>`}
      </div>
    </div>`;

    if (stock.length === 0) {
      html += `<div class="consig-status-page" style="min-height:200px">
        <div class="consig-status-page__inner">
          <div class="consig-status-page__icon">📦</div>
          <h3 class="consig-status-page__title">A aguardar a tua primeira entrega</h3>
          <p class="consig-status-page__text">O teu comercial está a preparar o teu kit inicial. Receberás os produtos em breve.</p>
        </div>
      </div>`;
    } else {
      html += `<div class="consig-table-wrap"><table class="consig-table">
        <thead><tr>
          <th>Produto</th><th>Qty em campo</th>
        </tr></thead><tbody>`;

      stock.forEach(item => {
        html += `<tr>
          <td>${item.produto_titulo || '—'}</td>
          <td><strong>${item.qty_atual}</strong></td>
        </tr>`;
      });
      html += `</tbody></table></div>`;
    }

    if (ultimoReporte) {
      const d = new Date(ultimoReporte.data_report).toLocaleDateString('pt-PT');
      html += `<p style="margin-top:20px;font-size:.85rem;color:var(--c-gray-500)">
        Último reporte: ${d} · ${fmt(ultimoReporte.valor_total)}
      </p>`;
    }

    panel.innerHTML = html;
  }

  // ── Catálogo ──────────────────────────────────────────────────────────────────

  async function loadCatalog() {
    const panel = qs('[data-panel="catalogo"]');
    try {
      const res  = await apiFetch('/consignment/catalog.php');
      catalogData = res.produtos || [];
      renderCatalog(panel);
    } catch (err) {
      panel.innerHTML = `<div class="consig-alert-inline consig-alert-inline--danger">Erro ao carregar catálogo: ${err.message}</div>`;
    }
  }

  function renderCatalog(panel) {
    if (catalogData.length === 0) {
      panel.innerHTML = '<p style="color:var(--c-gray-500)">Nenhum produto disponível de momento.</p>';
      return;
    }
    let html = '<div class="consig-products">';
    catalogData.forEach(p => {
      html += `<div class="consig-product-card">
        ${p.imagem ? `<img class="consig-product-card__img" src="${p.imagem}" alt="${p.titulo}" loading="lazy">` : '<div class="consig-product-card__img"></div>'}
        <div class="consig-product-card__body">
          <div class="consig-product-card__title">${p.titulo}</div>
          <div class="consig-product-card__price">${fmt(p.preco)}</div>
        </div>
      </div>`;
    });
    html += '</div>';
    panel.innerHTML = html;
  }

  // ── Reporte ───────────────────────────────────────────────────────────────────

  function renderReportForm() {
    const panel = qs('[data-panel="reporte"]');
    if (!stockData.length) {
      panel.innerHTML = `<div class="consig-alert-inline consig-alert-inline--warning">
        Não tens stock em campo para reportar.
      </div>`;
      return;
    }

    let html = `<h3 style="margin:0 0 8px;font-size:1.1rem">Seleciona as quantidades vendidas</h3>
      <p style="font-size:.9rem;color:var(--c-gray-500);margin:0 0 24px">Indica apenas produtos efetivamente vendidos.</p>
      <div id="consig-report-items">`;

    stockData.forEach(item => {
      html += `<div class="consig-field" style="flex-direction:row;align-items:center;justify-content:space-between;padding:14px 0;border-bottom:1px solid var(--c-gray-100)">
        <div>
          <div style="font-weight:600;font-size:.9rem">${item.produto_titulo || 'Produto'}</div>
          <div style="font-size:.8rem;color:var(--c-gray-500)">${item.qty_atual} em campo</div>
        </div>
        <div class="consig-product-card__qty">
          <button type="button" class="consig-qty-btn" onclick="this.nextElementSibling.nextElementSibling.value=Math.max(0,+this.nextElementSibling.nextElementSibling.value-1)">−</button>
          <input class="consig-qty-input report-qty"
            type="number" min="0" max="${item.qty_atual}"
            value="0"
            data-produto-id="${item.produto_shopify_id}"
            data-variant-id="${item.produto_variant_id || ''}"
            data-titulo="${(item.produto_titulo || '').replace(/"/g, '&quot;')}"
            data-stock="${item.qty_atual}">
          <button type="button" class="consig-qty-btn" onclick="this.previousElementSibling.value=Math.min(+this.previousElementSibling.dataset.stock,+this.previousElementSibling.value+1)">+</button>
        </div>
      </div>`;
    });

    html += `</div>
      <div style="margin-top:24px;text-align:right">
        <div id="consig-report-total" style="font-size:1rem;color:var(--c-gray-500);margin-bottom:12px"></div>
        <button class="consig-btn consig-btn--dark" id="consig-report-submit">Submeter reporte</button>
      </div>`;

    panel.innerHTML = html;

    // Não temos preços no stockData, vamos buscar do catálogo ou deixar a API calcular
    qs('#consig-report-submit').addEventListener('click', submitReport);
  }

  async function submitReport() {
    const inputs = qsa('.report-qty');
    const items  = [];
    let hasAny   = false;

    // Precisamos de preços — buscar catálogo se não carregado
    if (catalogData.length === 0) {
      try { const r = await apiFetch('/consignment/catalog.php'); catalogData = r.produtos || []; } catch {}
    }

    const precos = {};
    catalogData.forEach(p => {
      precos[p.id] = p.preco;
      p.variants.forEach(v => { precos[`v_${v.id}`] = v.preco; });
    });

    inputs.forEach(input => {
      const qty = parseInt(input.value);
      if (qty > 0) {
        hasAny = true;
        const variantId  = parseInt(input.dataset.variantId) || null;
        const produtoId  = parseInt(input.dataset.produtoId);
        const preco = precos[`v_${variantId}`] || precos[produtoId] || 0;
        items.push({
          produto_shopify_id: produtoId,
          produto_variant_id: variantId,
          produto_titulo:     input.dataset.titulo,
          qty_vendida:        qty,
          preco_unitario:     preco,
        });
      }
    });

    if (!hasAny) { toast('Seleciona pelo menos um produto.', 'warning'); return; }

    const btn = qs('#consig-report-submit');
    btn.disabled = true;
    btn.textContent = 'A processar...';

    try {
      const res = await apiFetch('/consignment/report.php', {
        method: 'POST',
        body: JSON.stringify({ items }),
      });
      toast(res.message, 'success', 6000);
      await loadPortal();
    } catch (err) {
      toast(err.message, 'error');
      btn.disabled    = false;
      btn.textContent = 'Submeter reporte';
    }
  }

  // ── Reposição ──────────────────────────────────────────────────────────────────

  async function renderReorderForm() {
    const panel = qs('[data-panel="reposicao"]');

    // Verificar se tem pagamento pendente
    try {
      const stockRes = await apiFetch('/consignment/stock.php');
      if (stockRes.pagamento_pendente) {
        const r = stockRes.ultimo_reporte;
        panel.innerHTML = `<div class="consig-alert-inline consig-alert-inline--danger">
          🔒 Tens um pagamento pendente de <strong>${fmt(r.valor_total)}</strong> (encomenda #${r.shopify_order_number}).
          O pedido de reposição fica disponível após o pagamento.
        </div>`;
        return;
      }
    } catch {}

    // Carregar catálogo se necessário
    if (catalogData.length === 0) {
      panel.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div> A carregar...</div>';
      await loadCatalog();
    }

    if (catalogData.length === 0) {
      panel.innerHTML = '<p style="color:var(--c-gray-500)">Nenhum produto disponível.</p>';
      return;
    }

    let html = `<h3 style="margin:0 0 8px;font-size:1.1rem">Pedido de reposição</h3>
      <p style="font-size:.9rem;color:var(--c-gray-500);margin:0 0 24px">Seleciona os produtos e quantidades que pretendes repor.</p>
      <div class="consig-products" id="consig-reorder-items">`;

    catalogData.forEach(p => {
      const variantId = p.variants[0]?.id || '';
      html += `<div class="consig-product-card">
        ${p.imagem ? `<img class="consig-product-card__img" src="${p.imagem}" alt="${p.titulo}" loading="lazy">` : '<div class="consig-product-card__img"></div>'}
        <div class="consig-product-card__body">
          <div class="consig-product-card__title">${p.titulo}</div>
          <div class="consig-product-card__price">${fmt(p.preco)}</div>
          <div class="consig-product-card__qty">
            <button type="button" class="consig-qty-btn" onclick="this.nextElementSibling.nextElementSibling.value=Math.max(0,+this.nextElementSibling.nextElementSibling.value-1);updateReorderTotal()">−</button>
            <input class="consig-qty-input reorder-qty"
              type="number" min="0" value="0"
              data-variant-id="${variantId}"
              data-preco="${p.preco}"
              data-titulo="${(p.titulo).replace(/"/g, '&quot;')}">
            <button type="button" class="consig-qty-btn" onclick="this.previousElementSibling.value=+this.previousElementSibling.value+1;updateReorderTotal()">+</button>
          </div>
        </div>
      </div>`;
    });

    html += `</div>
      <div style="margin-top:24px;text-align:right">
        <div id="consig-reorder-total" style="font-size:1rem;color:var(--c-gray-500);margin-bottom:12px">Total: ${fmt(0)}</div>
        <button class="consig-btn consig-btn--dark" id="consig-reorder-submit">Pedir reposição</button>
      </div>`;

    panel.innerHTML = html;

    qsa('.reorder-qty').forEach(i => i.addEventListener('input', updateReorderTotal));
    qs('#consig-reorder-submit').addEventListener('click', submitReorder);
  }

  function updateReorderTotal() {
    const inputs = qsa('.reorder-qty');
    const total  = inputs.reduce((s, i) => s + (+i.value * +i.dataset.preco), 0);
    const el     = qs('#consig-reorder-total');
    if (el) el.textContent = `Total estimado: ${fmt(total)}`;
  }

  window.updateReorderTotal = updateReorderTotal;

  async function submitReorder() {
    const inputs = qsa('.reorder-qty');
    const items  = [];

    inputs.forEach(input => {
      const qty = parseInt(input.value);
      if (qty > 0) {
        items.push({
          variant_id: parseInt(input.dataset.variantId),
          qty,
        });
      }
    });

    if (!items.length) { toast('Seleciona pelo menos um produto.', 'warning'); return; }

    const btn = qs('#consig-reorder-submit');
    btn.disabled = true;
    btn.textContent = 'A processar...';

    try {
      const res = await apiFetch('/consignment/reorder.php', {
        method: 'POST',
        body: JSON.stringify({ items }),
      });
      toast(res.message, 'success', 6000);
      await loadPortal();
    } catch (err) {
      toast(err.message, 'error');
      btn.disabled    = false;
      btn.textContent = 'Pedir reposição';
    }
  }

  // ── Kit inicial ────────────────────────────────────────────────────────────────

  async function renderKitForm() {
    const panel = qs('[data-panel="kit"]');
    if (!panel) return;

    if (catalogData.length === 0) {
      panel.innerHTML = '<div class="consig-loading"><div class="consig-spinner"></div> A carregar catálogo...</div>';
      await loadCatalog();
    }

    if (catalogData.length === 0) {
      panel.innerHTML = '<p style="color:var(--c-gray-500)">Nenhum produto disponível.</p>';
      return;
    }

    let html = `<h3 style="margin:0 0 8px;font-size:1.1rem">Kit inicial</h3>
      <p style="font-size:.9rem;color:var(--c-gray-500);margin:0 0 16px">
        Seleciona os produtos para o teu primeiro kit. O total não pode exceder o limite disponível.
      </p>
      <div class="consig-alert-inline consig-alert-inline--warning" style="margin-bottom:24px">
        ⚠️ Limite disponível: <strong>${fmt(kitLimite)}</strong>
      </div>
      <div class="consig-products" id="consig-kit-items">`;

    catalogData.forEach(p => {
      const variantId = p.variants[0]?.id || '';
      html += `<div class="consig-product-card">
        ${p.imagem ? `<img class="consig-product-card__img" src="${p.imagem}" alt="${p.titulo}" loading="lazy">` : '<div class="consig-product-card__img"></div>'}
        <div class="consig-product-card__body">
          <div class="consig-product-card__title">${p.titulo}</div>
          <div class="consig-product-card__price">${fmt(p.preco)}</div>
          <div class="consig-product-card__qty">
            <button type="button" class="consig-qty-btn" onclick="this.nextElementSibling.nextElementSibling.value=Math.max(0,+this.nextElementSibling.nextElementSibling.value-1);updateKitTotal()">−</button>
            <input class="consig-qty-input kit-qty"
              type="number" min="0" value="0"
              data-variant-id="${variantId}"
              data-preco="${p.preco}"
              data-titulo="${(p.titulo).replace(/"/g, '&quot;')}">
            <button type="button" class="consig-qty-btn" onclick="this.previousElementSibling.value=+this.previousElementSibling.value+1;updateKitTotal()">+</button>
          </div>
        </div>
      </div>`;
    });

    html += `</div>
      <div style="margin-top:24px;text-align:right">
        <div id="consig-kit-total" style="font-size:1rem;color:var(--c-gray-500);margin-bottom:12px">Total: ${fmt(0)} / ${fmt(kitLimite)}</div>
        <button class="consig-btn consig-btn--dark" id="consig-kit-submit">Pedir kit inicial</button>
      </div>`;

    panel.innerHTML = html;
    qsa('.kit-qty').forEach(i => i.addEventListener('input', updateKitTotal));
    qs('#consig-kit-submit').addEventListener('click', submitKit);
  }

  function updateKitTotal() {
    const inputs = qsa('.kit-qty');
    const total  = inputs.reduce((s, i) => s + (+i.value * +i.dataset.preco), 0);
    const el     = qs('#consig-kit-total');
    if (el) el.textContent = `Total estimado: ${fmt(total)} / ${fmt(kitLimite)}`;
  }

  window.updateKitTotal = updateKitTotal;

  async function submitKit() {
    const inputs = qsa('.kit-qty');
    const items  = [];
    let total    = 0;

    inputs.forEach(input => {
      const qty = parseInt(input.value);
      if (qty > 0) {
        items.push({ variant_id: parseInt(input.dataset.variantId), qty });
        total += qty * parseFloat(input.dataset.preco);
      }
    });

    if (!items.length) { toast('Seleciona pelo menos um produto.', 'warning'); return; }
    if (kitLimite > 0 && total > kitLimite) {
      toast(`Total (${fmt(total)}) excede o limite (${fmt(kitLimite)}).`, 'error');
      return;
    }

    const btn = qs('#consig-kit-submit');
    btn.disabled = true;
    btn.textContent = 'A processar...';

    try {
      const res = await apiFetch('/consignment/kit.php', {
        method: 'POST',
        body: JSON.stringify({ items }),
      });
      toast(res.message, 'success', 6000);
      await loadPortal();
    } catch (err) {
      toast(err.message, 'error');
      btn.disabled    = false;
      btn.textContent = 'Pedir kit inicial';
    }
  }

  // ── Formulário de registo (landing) ───────────────────────────────────────────

  function initRegisterForm() {
    const form = qs('#consig-register-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const err = qs('#consig-form-error');
      const suc = qs('#consig-form-success');
      const btn = qs('#consig-form-submit');
      hide(err); hide(suc);
      btn.disabled = true;
      btn.textContent = 'A enviar...';

      const data = Object.fromEntries(new FormData(form));

      try {
        await apiFetch('/register.php', {
          method: 'POST',
          body: JSON.stringify(data),
        });
        const inner = qs('#consig-form-inner');
        if (inner) hide(inner);
        show(suc);
      } catch (error) {
        show(err);
        err.textContent = error.message;
        err.style.display = 'block';
      } finally {
        btn.disabled    = false;
        btn.textContent = 'Enviar candidatura';
      }
    });
  }

  // ── Init ─────────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const previewCid = params.get('preview');
    const adminSection = qs('[data-admin-cid]');

    // Botão "Ver como visitante" — mostra landing sem autenticação
    const toggleBtn = qs('#consig-toggle-visitor');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', () => {
        const landing = qs('#consig-landing');
        const isVisible = landing && landing.style.display !== 'none';
        if (isVisible) {
          landing.style.display = 'none';
          toggleBtn.textContent = 'Ver como visitante';
        } else {
          if (landing) landing.style.display = '';
          toggleBtn.textContent = 'Fechar pré-visualização';
          landing && landing.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    if (previewCid && adminSection) {
      // Modo preview: admin vê portal de um cliente específico
      adminSection.style.display = 'none';
      const root = qs('[data-consig-root]');
      if (root) {
        root.style.display = '';
        initPortalPreview(adminSection.dataset.adminCid, previewCid);
      }
      return;
    }

    const root = qs('[data-consig-root]');
    if (!root) return;

    const customerId = root.dataset.customerId;

    if (customerId) {
      initPortal(customerId);
    } else {
      initRegisterForm();
    }
  });

})();
